import angular from 'angular';
import ClientEmailMobileInput from './clientEmailMobileInput';

export default angular
  .module('components.clientEmailMobileInput', [])
  .component('clientEmailMobileInput', ClientEmailMobileInput).name;
